import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WebApiBaseService } from '../../shared/web-api-base/web-api-base.service';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/auth/auth.service';

export interface VentaDiaria {
  fecha: string;
  totalPesos: number;
  totalKg: number;
}

export interface ImpagoEnviado {
  idMadre: string;
  cliente: string;
  contactEmail: string;
  fecha: string;
  fechaEntrega: string;
  total: number;
  totalKg: number;
}

@Injectable()
export class InicioService extends WebApiBaseService {

  constructor(private http: HttpClient, private route: Router, private authService: AuthService) {
    super();
  }

  getVentasDiarias(desde: Date, hasta: Date): Observable<VentaDiaria[]> {
    const params = new HttpParams()
      .set('desde', this.formatDate(desde))
      .set('hasta', this.formatDate(hasta));
    const options = { headers: this.authService.createHeaders(), params };
    return this.http.get<VentaDiaria[]>(this.baseUrl + 'Dashboard/VentasDiarias', options);
  }

  // Pedidos entregados (shipped) todavia sin cobrar: saldo por cobrar.
  getImpagosEnviados(): Observable<ImpagoEnviado[]> {
    const options = { headers: this.authService.createHeaders() };
    return this.http.get<ImpagoEnviado[]>(this.baseUrl + 'Dashboard/ImpagosEnviados', options);
  }

  getProductosVentas(desde: Date, hasta: Date): Observable<any[]> {
    const params = new HttpParams()
      .set('dateFrom', this.formatDate(desde))
      .set('dateTo', this.formatDate(hasta));
    const options = { headers: this.authService.createHeaders(), params };
    return this.http.get<any[]>(this.baseUrl + 'Produccion/GetProduccionFecha', options);
  }

  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
}
